import useAuth from "hooks/useAuth"

export function useCurrentDepartmentAccess() {
  const user = useAuth()
  return user.user?.currentDepartment?.access?.codename === "ECOM"
}
